import { Component } from "react";
import ToggleField from "../../../components/inputs/toggleField";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import FormSubmissionsModal from "./modals/formSubmissionsModal";

const ENV =
    process.env.NODE_ENV === "production"
        ? window.location.href.includes("planner.simple.events")
            ? `https://admin-api.simple.events/`
            : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

class SessionCheckinSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formSubmissionModalOpen: false,
        };
    }
    render() {
        const {
            checkInAppConfiguration,
            orgId,
            eventId,
            programId,
            sessionCheckInFormId,
            handleChange,
            formManager,
            account,
            editCount,
        } = this.props;
        const { formSubmissionModalOpen } = this.state;
        return (
            <div className="sectionBody">
                <div className="blocksContainer">
                    <div className="flex w-100">
                        <div className="sectionBlock mr-25 contained-h">
                            <h2 className="blockHeader">Setup</h2>
                            <ToggleField
                                label="Use Checkin Form"
                                disabled={
                                    checkInAppConfiguration.enabled &&
                                    !checkInAppConfiguration.sessionCheckInForm
                                }
                                alert={
                                    checkInAppConfiguration.enabled &&
                                        !checkInAppConfiguration.sessionCheckInForm
                                        ? "App must be disabled to configure new session checkin form"
                                        : null
                                }
                                checked={checkInAppConfiguration.useCheckinFormForSession}
                                onChange={(e) => {
                                    handleChange({ useCheckinFormForSession: e.target.checked });
                                }}
                                icons={false}
                            />

                            {checkInAppConfiguration.useCheckinFormForSession && !programId && (
                                <button
                                    className="neu"
                                    onClick={() =>
                                        this.setState({ formSubmissionModalOpen: true })
                                    }
                                >
                                    View Submissions
                                </button>)}
                        </div>
                        {!checkInAppConfiguration.useCheckinFormForSession && (
                            <div
                                style={{ padding: 5, minWidth: 490 }}
                                className="sectionBlock contained-h emailDesignPreview mt-20 "
                            >
                                <div
                                    style={{
                                        width: 590,
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                    }}
                                    className="cardDetailsContainerPages containerTitle mb-20"
                                >
                                    <div className="w-100">
                                        <h2 className="blockHeader m-0">Form Builder</h2>
                                    </div>

                                    {!checkInAppConfiguration.sessionCheckInForm ? (
                                        <button
                                            className="neu ml-a"
                                            onClick={formManager.toggleFormEditorModal}
                                        >
                                            Add Form
                                        </button>
                                    ) : (
                                        <div className="flex aic ml-a">
                                            {!programId && <button
                                                className="neu mr-10"
                                                onClick={() =>
                                                    this.setState({ formSubmissionModalOpen: true })
                                                }
                                            >
                                                View Submissions
                                            </button>}

                                            <button
                                                className="neu prim"
                                                onClick={formManager.toggleFormEditorModal}
                                            >
                                                Edit Form
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div
                                    style={{
                                        width: 590,
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                        height: 500,
                                    }}
                                >
                                    <div className="emailPreview eFrame pages flex-ac preview">
                                        {sessionCheckInFormId ? (
                                            <PagePreviewFrame
                                                ENV={ENV}
                                                key={`session-${editCount}`}
                                                renderURL={!programId ? `Organizations/${orgId}/events/${eventId}/pages/render/formRender/` : `Organizations/${orgId}/programs/${programId}/render/sessionCheckInForm/`}
                                                pageProperties={{}}
                                                focusedComponent={""}
                                                simulatedUser={{ value: account._id }}
                                                simulatedSession={{ value: false }}
                                                renderOnly={true}
                                                formId={sessionCheckInFormId}
                                                preview={true}
                                            />
                                        ) : (
                                            <div className="flex column aic jcc w-100">
                                                <h3>Add a form to get started</h3>
                                                <p>A preview will show here.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {formSubmissionModalOpen && <FormSubmissionsModal
                    key={`sessionFormSubmissions`}
                    isOpen={formSubmissionModalOpen}
                    toggle={() => this.setState({ formSubmissionModalOpen: false })}
                    form={!checkInAppConfiguration.useCheckinFormForSession ? checkInAppConfiguration.sessionCheckInForm : checkInAppConfiguration.checkInForm}
                    formType={"sessionCheckInForm"}
                    orgId={this.props.orgId}
                    eventId={this.props.eventId}
                    programId={this.props.programId}
                    event={this.props.event}
                    
                />}
            </div >
        );
    }
}

export default SessionCheckinSetup;
